export const CONVERSATION_SOURCE = {
  UPLOADED: "uploaded",
  SIMULATED: "simulated",
} as const

export type ConversationSource =
  (typeof CONVERSATION_SOURCE)[keyof typeof CONVERSATION_SOURCE]
export type ConversationSourceFilter = ConversationSource | "all"

export function normalizeConversationSource(
  value: unknown,
): ConversationSource | undefined {
  switch (value) {
    case "uploaded":
    case "UPLOADED":
    case "monitoring":
    case "Monitoring":
    case "MONITORING":
      return CONVERSATION_SOURCE.UPLOADED
    case "simulated":
    case "SIMULATED":
    case "simulation":
    case "Simulation":
    case "SIMULATION":
    case "simulations":
    case "Simulations":
      return CONVERSATION_SOURCE.SIMULATED
    default:
      return undefined
  }
}

export function normalizeConversationSourceFilter(
  value: unknown,
): ConversationSourceFilter | undefined {
  if (value === "all" || value === "ALL") {
    return "all"
  }
  return normalizeConversationSource(value)
}

export function toTransportConversationSource(
  source: ConversationSource,
): "UPLOADED" | "SIMULATED" {
  return source === CONVERSATION_SOURCE.UPLOADED ? "UPLOADED" : "SIMULATED"
}

export function toTransportConversationSourceFilter(
  source: ConversationSourceFilter,
): "ALL" | "UPLOADED" | "SIMULATED" {
  return source === "all" ? "ALL" : toTransportConversationSource(source)
}
